import React from 'react';
import { useSnackbar } from 'notistack';
import { Switch } from '@curves/ui-base';
import useProductApi from '@Apis/useProductApi';
import useMessageDialog from '@Util/hook/useMessageDialog';

/**
 * 商品總覽上下架開關
 * - 開關兩方向都需經確認彈窗才會實際送出；關閉彈窗則開關維持原值
 * - 確認成功：重新查詢列表；確認失敗：開關維持原值並顯示錯誤訊息
 */
const ProductEnabledSwitch = ({ productID, isEnabled, onUpdated }) => {
    const { putProductEnabledApi } = useProductApi();
    const { enqueueSnackbar } = useSnackbar();
    const setMessageDialog = useMessageDialog();

    // 送出上下架；成功重新查詢列表，失敗顯示錯誤訊息
    const submitEnabled = async (nextEnabled) => {
        const success = await putProductEnabledApi(productID, nextEnabled);
        if (success) {
            onUpdated();
        } else {
            enqueueSnackbar('商品上下架失敗，請稍後再試', { variant: 'error' });
        }
    };

    // 切換開關時先開確認彈窗，不直接送出
    const handleChange = (_e, nextChecked) => {
        const nextEnabled = Boolean(nextChecked);
        setMessageDialog({
            open: true,
            title: '上下架確認',
            msg: nextEnabled
                ? '確認要將此商品所有規格一起上架嗎？'
                : '確認要將此商品所有規格一起下架嗎？此操作將會同步停止該商品底下所有規格之販售狀態。',
            buttonText: nextEnabled ? '確認上架' : '確認下架',
            onConfirm: () => submitEnabled(nextEnabled),
        });
    };

    return <Switch checked={Boolean(isEnabled)} onChange={handleChange} />;
};

export default ProductEnabledSwitch;
